/* Mittis – kokosuositus. Saarni / Prestige.
 * Data tulee Mittataulukko-metaobjekteista (snippets/mittis.liquid).
 * Tekstit tulevat teeman kielitiedostosta (mittis.*), joten käännössovellus kääntää ne.
 * Asiakkaan mittoja ei lähetetä minnekään eikä tallenneta.
 */
(function () {
  'use strict';

  /* ---------- Oletustekstit (suomi) – käytetään vain jos käännös puuttuu ---------- */
  var FI = {
    trigger: 'Etsi kokosi',
    title: 'Etsi kokosi',
    intro: 'Syötä omat mittasi senttimetreinä. Vertaamme niitä tämän tuotteen mittoihin ja ehdotamme sopivinta kokoa.',
    loading: 'Ladataan…',
    measure_heading: 'Omat mittasi',
    neck: 'Kaulan ympärys',
    neck_help: 'Mittaa kaulan tyvestä, aataminomenan alapuolelta. Jätä yksi sormi mittanauhan alle.',
    chest: 'Rinnanympärys',
    chest_help: 'Mittaa rinnan leveimmästä kohdasta kainaloiden alta, nauha vaakasuorassa.',
    waist: 'Vyötärönympärys',
    waist_help: 'Mittaa vatsan kohdalta, navan korkeudelta.',
    waist_trousers_help: 'Mittaa kohdasta, jossa housujen vyötärö on (yleensä hieman navan alapuolella).',
    hip: 'Lantionympärys',
    hip_help: 'Mittaa pakaroiden leveimmästä kohdasta.',
    inseam: 'Sisäpituus (valinnainen)',
    inseam_help: 'Haaroista lattiaan, kengät pois jalasta.',
    cm: 'cm',
    calculate: 'Näytä suositus',
    result_heading: 'Suosituksemme',
    recommended: 'Suosittelemme kokoa',
    borderline: 'Olet kokojen rajalla. Valitse [other], jos pidät väljemmästä istuvuudesta.',
    between: 'tai',
    too_small: 'Pieninkin koko voi olla sinulle hieman väljä.',
    too_large: 'Suurinkin koko voi olla sinulle hieman tiukka.',
    select_size: 'Valitse koko [size]',
    size_selected: 'Koko [size] valittu.',
    size_not_found: 'Valitse koko [size] tuotesivulta.',
    not_sold: 'ei myynnissä',
    fit_tight: 'Tiukka',
    fit_ideal: 'Sopiva',
    fit_loose: 'Väljä',
    garment: 'Vaate',
    body: 'Sinä',
    chart_heading: 'Tuotteen mitat',
    show_chart: 'Näytä mittakuva',
    group_jacket: 'Takki',
    group_trousers: 'Housut',
    group_shirt: 'Paita',
    missing_input: 'Täytä vähintään yksi mitta.',
    inseam_short: 'Lahje voi jäädä sinulle lyhyeksi.',
    inseam_long: 'Lahje on sinulle pitkä – sen voi lyhentää.',
    how_to_measure: 'Miten mittaan?',
    legend: 'Palkki näyttää, miten vaate istuu kussakin koossa.',
    disclaimer: 'Mitat on otettu vaatteesta. Suositus on arvio – tarvittaessa autamme mielellämme.',
    best_sold_out: 'Sopivin kokosi [size] on tästä tuotteesta valitettavasti loppunut.',
    alt_heading: 'Kokosi [size] löytyy näistä saman kategorian tuotteista',
    alt_loading: 'Etsitään saman kategorian tuotteita, joissa kokosi on saatavilla…',
    alt_none: 'Samasta kategoriasta ei juuri nyt löytynyt tuotetta, jossa kokosi olisi saatavilla. Kysy meiltä – autamme mielellämme.',
    alt_size: 'Sinun kokosi: [size]',
    also_fits: 'Tästä tuotteesta saatavilla oleva koko [size] on vielä mittojesi rajoissa, mutta ei yhtä hyvä kuin [ideal].',
    row_collar: 'Kaulus', row_shoulder: 'Hartialeveys', row_chest: 'Rinnanympärys', row_waist: 'Vyötärönympärys',
    row_hip: 'Lantionympärys', row_sleeve: 'Hihan pituus', row_length: 'Pituus', row_inseam: 'Sisäpituus',
    row_thigh: 'Reiden ympärys', row_leg_width: 'Lahkeen leveys'
  };

  /* ---------- Rivien tunnistus ---------- */
  var ROWS = {
    'kaulus': 'collar', 'kaulus koko': 'collar', 'kauluksen koko': 'collar', 'kaulan ympärys': 'collar',
    'hartialeveys': 'shoulder', 'olkaleveys': 'shoulder',
    'rinnan ympärys': 'chest', 'rinnanympärys': 'chest', 'rinta': 'chest',
    'vyötärön ympärys': 'waist', 'vyötärönympärys': 'waist', 'vyötärö': 'waist',
    'lantion ympärys': 'hip', 'lantionympärys': 'hip', 'lantio': 'hip',
    'hihan pituus': 'sleeve', 'hiha': 'sleeve',
    'pituus': 'length', 'selän pituus': 'length',
    'sisäpituus': 'inseam', 'lahkeen sisäsauma': 'inseam', 'lahkeen pituus': 'leg_length',
    'reiden ympärys': 'thigh', 'lahkeen leveys': 'leg_width'
  };

  function normSize(s) {
    s = String(s == null ? '' : s).trim().toUpperCase().replace(/\s+/g, '');
    var map = { 'XXXL': '3XL', 'XXXXL': '4XL', 'XXXXXL': '5XL', '2XL': 'XXL' };
    return map[s] || s;
  }
  function num(s) {
    var v = parseFloat(String(s).replace(',', '.').replace(/[^0-9.\-]/g, ''));
    return isFinite(v) ? v : null;
  }

  /* Mitat-kenttä (Excelistä liitetty) → {sizes:[], rows:{key:{label, values:[]}}, order:[]} */
  function parseTable(text) {
    var lines = String(text || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
    var split = function (l) {
      if (l.indexOf('\t') > -1) return l.split('\t');
      if (l.indexOf(';') > -1) return l.split(';');
      return l.split(/\s{2,}|\s(?=[0-9])/);
    };
    var out = { sizes: [], rows: {}, order: [] };
    lines.forEach(function (line, i) {
      var cells = split(line).map(function (c) { return c.trim(); });
      if (i === 0) { out.sizes = cells.slice(1).filter(Boolean).map(normSize); return; }
      var label = cells[0];
      var key = ROWS[label.toLowerCase()] || ('x:' + label);
      var values = cells.slice(1, out.sizes.length + 1).map(num);
      out.rows[key] = { label: label, values: values };
      out.order.push(key);
    });
    return out;
  }

  /* ---------- Väljyys (vaatteen mitta − vartalon mitta), [min, ihanne, max] cm ---------- */
  var EASE = {
    Kauluspaita: {
      collar: { Slim: [-0.5, 0.5, 2], Regular: [-0.5, 0.5, 2], 'Väljä': [-0.5, 1, 2.5] },
      chest:  { Slim: [2, 5, 10], Regular: [4, 8, 16], 'Väljä': [8, 14, 24] },
      waist:  { Slim: [2, 7, 14], Regular: [4, 10, 20], 'Väljä': [8, 16, 28] }
    },
    Bleiseri: {
      chest: { Slim: [4, 8, 14], Regular: [6, 10, 16], 'Väljä': [10, 14, 22] },
      waist: { Slim: [2, 8, 14], Regular: [4, 10, 18], 'Väljä': [8, 14, 24] }
    },
    Housut: {
      waist: { Slim: [-1, 1, 4], Regular: [0, 2, 5], 'Väljä': [0, 3, 7] },
      hip:   { Slim: [2, 6, 10], Regular: [4, 8, 14], 'Väljä': [8, 12, 20] }
    }
  };
  EASE.Puku = EASE.Bleiseri;

  var INPUTS = {
    Kauluspaita: [['neck', 'collar'], ['chest', 'chest'], ['waist', 'waist']],
    Bleiseri: [['chest', 'chest'], ['waist', 'waist']],
    Housut: [['waist', 'waist'], ['hip', 'hip'], ['inseam', 'inseam']]
  };
  INPUTS.Puku = INPUTS.Bleiseri;

  /* Ensisijainen mitta: paidoissa kaulus (jos annettu), takeissa rinta, housuissa vyötärö */
  var PRIMARY = { Kauluspaita: ['collar', 'chest'], Bleiseri: ['chest', 'waist'], Puku: ['chest', 'waist'], Housut: ['waist', 'hip'] };

  /* Tagit: ease_12  (ensisijaisen ihanne)  |  ease_chest_14  |  ease_chest_8_12_18 */
  function easeFor(group, fit, key, tags, primaryKey) {
    var base = ((EASE[group] || {})[key] || {})[fit] || ((EASE[group] || {})[key] || {}).Regular;
    if (!base) return null;
    var e = base.slice();
    (tags || []).forEach(function (t) {
      var m = /^ease_(-?\d+(?:\.\d+)?)$/.exec(t);
      if (m && key === primaryKey) { var d = parseFloat(m[1]) - e[1]; e = [e[0] + d, e[1] + d, e[2] + d]; }
      var m2 = new RegExp('^ease_' + key + '_(-?\\d+(?:\\.\\d+)?)(?:_(-?\\d+(?:\\.\\d+)?)_(-?\\d+(?:\\.\\d+)?))?$').exec(t);
      if (m2) {
        if (m2[2] != null) e = [parseFloat(m2[1]), parseFloat(m2[2]), parseFloat(m2[3])];
        else { var d2 = parseFloat(m2[1]) - e[1]; e = [e[0] + d2, e[1] + d2, e[2] + d2]; }
      }
    });
    return e;
  }

  /* ---------- Suositus ---------- */
  function recommend(chart, body, tags, sellable) {
    var group = chart.group, fit = chart.fit || 'Regular';
    var t = chart.parsed;
    var prim = (PRIMARY[group] || ['chest']).filter(function (k) { return body[k] != null && t.rows[k]; })[0];
    var keys = Object.keys(body).filter(function (k) { return body[k] != null && t.rows[k] && easeFor(group, fit, k, tags, prim); });
    if (!keys.length) return null;

    var sizes = t.sizes.map(function (s, i) {
      var score = 0, hardFail = 0, over = 0, per = {};
      keys.forEach(function (k) {
        var g = t.rows[k].values[i];
        if (g == null) return;
        var e = easeFor(group, fit, k, tags, prim);
        var lo = body[k] + e[0], id = body[k] + e[1], hi = body[k] + e[2];
        var w = (k === prim) ? 1 : 0.5;
        score += w * Math.abs(g - id);
        if (g < lo) { hardFail += (lo - g); score += 4 * (lo - g); }
        if (g > hi) { over += (g - hi); score += 1.5 * (g - hi); }
        per[k] = { g: g, lo: lo, id: id, hi: hi };
      });
      return { size: s, i: i, score: score, hardFail: hardFail, over: over, per: per, sellable: sellable(s) };
    });

    var candidates = sizes.filter(function (s) { return s.sellable; });
    if (!candidates.length) candidates = sizes;
    var sorted = candidates.slice().sort(function (a, b) { return a.score - b.score; });
    var best = sorted[0];
    var overall = sizes.slice().sort(function (a, b) { return a.score - b.score; })[0];
    var soldOut = (overall && !overall.sellable) ? overall.size : null;
    /* Saatavilla oleva koko kelpaa varakooksi vain, jos se on kaikilla mitoilla sallituissa rajoissa. */
    var alsoFits = (soldOut && best.sellable && best.hardFail === 0 && best.over === 0) ? best.size : null;
    var note = null;
    if (sizes.every(function (s) { return s.hardFail > 0; })) note = 'too_large';
    else if (sizes.every(function (s) { return s.over > 0; })) note = 'too_small';

    var other = null;
    var bigger = candidates.filter(function (s) { return s.i === best.i + 1; })[0];
    if (bigger && bigger.hardFail === 0 && bigger.score - best.score < 2.5) other = bigger.size;

    var extra = [];
    if (body.inseam != null && t.rows.inseam) {
      var gi = t.rows.inseam.values[best.i];
      if (gi != null && gi < body.inseam - 2) extra.push('inseam_short');
      else if (gi != null && gi > body.inseam + 4) extra.push('inseam_long');
    }
    return { best: best, ideal: overall, other: other, note: note, extra: extra, sizes: sizes, keys: keys, prim: prim, soldOut: soldOut, alsoFits: alsoFits };
  }

  /* Tuotteen "laji" mittataulukoiden perusteella: paita / takki / housut / shortsit / puku (takki+housut). */
  function chartKind(c) {
    if (c.group === 'Housut') {
      var r = c.parsed.rows.inseam || c.parsed.rows.leg_length;
      var vals = r ? r.values.filter(function (v) { return v != null; }) : [];
      var avg = vals.length ? vals.reduce(function (a, b) { return a + b; }, 0) / vals.length : null;
      if (/short/i.test(c.name || '') || (avg != null && avg < 45)) return 'Shortsit';
      return 'Housut';
    }
    return c.group === 'Puku' ? 'Bleiseri' : c.group;
  }
  function kindOf(charts) {
    var k = charts.map(chartKind).filter(function (v, i, a) { return a.indexOf(v) === i; });
    return k.sort().join('+');
  }

  /* Vaihtoehtojen data: /collections/<h>/mittis?view=mittis  (templates/collection.mittis.liquid) */
  var altCache = {};
  function fetchCollection(handle) {
    if (altCache[handle]) return altCache[handle];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var base = root + 'collections/' + encodeURIComponent(handle) + '/mittis?view=mittis';
    var getPage = function (n) {
      return fetch(base + (n > 1 ? '&page=' + n : ''), { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
        .then(function (txt) { return JSON.parse(txt); });
    };
    altCache[handle] = getPage(1).then(function (first) {
      var more = [];
      for (var n = 2; n <= Math.min(first.pages || 1, 6); n++) more.push(getPage(n));
      return Promise.all(more).then(function (rest) {
        rest.forEach(function (r) { first.products = first.products.concat(r.products || []); });
        (first.charts || []).forEach(function (c) { c.parsed = parseTable(c.table); });
        return first;
      });
    }).catch(function (e) { console.warn('[Mittis] vaihtoehdot', handle, e); return { charts: [], products: [] }; });
    return altCache[handle];
  }

  /* ---------- Web-komponentti ---------- */
  class MittisWidget extends HTMLElement {}

  MittisWidget.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;
    var cfgEl = this.querySelector('[data-mittis-config]');
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[Mittis] config', e); return; }
    var t = this.cfg.t || {};
    this.t = function (k, vars) {
      var s = (t[k] && String(t[k]).trim()) || FI[k] || k;
      if (vars) Object.keys(vars).forEach(function (v) { s = s.split('[' + v + ']').join(vars[v]).replace(new RegExp('{{\\s*' + v + '\\s*}}', 'g'), vars[v]); });
      return s;
    };
    this.cfg.charts.forEach(function (c) { c.parsed = parseTable(c.table); });
    var avail = (this.cfg.available || []).filter(Boolean).map(normSize);
    var sold = (this.cfg.sizes || []).map(normSize);
    this.sellable = function (s) { return sold.indexOf(s) > -1 && avail.indexOf(s) > -1; };
    this.onSale = function (s) { return sold.indexOf(s) > -1; };
    this.active = 0;

    var self = this;
    this.querySelectorAll('[data-mittis-text]').forEach(function (el) { el.textContent = self.t(el.getAttribute('data-mittis-text')); });
    this.querySelector('[data-mittis-open]').addEventListener('click', function () { self.open(); });
  };

  MittisWidget.prototype.groupLabel = function (g) {
    return g === 'Housut' ? this.t('group_trousers') : g === 'Kauluspaita' ? this.t('group_shirt') : this.t('group_jacket');
  };
  MittisWidget.prototype.rowLabel = function (key, raw) {
    if (key.indexOf('x:') === 0) return raw;
    var k = 'row_' + key;
    var tv = this.cfg.t && this.cfg.t[k];
    return (tv && String(tv).trim()) || FI[k] || raw;
  };

  MittisWidget.prototype.open = function () {
    if (!this.dialog) this.build();
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
    document.documentElement.classList.add('mittis-lock');
  };
  MittisWidget.prototype.close = function () {
    if (this.dialog.close) this.dialog.close(); else this.dialog.removeAttribute('open');
    document.documentElement.classList.remove('mittis-lock');
  };

  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') el.textContent = attrs[k];
      else if (k === 'html') el.innerHTML = attrs[k];
      else el.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) el.appendChild(c); });
    return el;
  }

  MittisWidget.prototype.build = function () {
    var self = this;
    var d = h('dialog', { 'class': 'mittis__dialog', 'aria-labelledby': 'mittis-title' });
    var header = h('div', { 'class': 'mittis__header' }, [
      h('div', {}, [h('h2', { 'class': 'mittis__title h5', id: 'mittis-title', text: this.t('title') }), h('p', { 'class': 'mittis__product', text: this.cfg.product })]),
      h('button', { type: 'button', 'class': 'mittis__close', 'aria-label': 'Close', html: '&times;' })
    ]);
    var scroll = h('div', { 'class': 'mittis__scroll' });
    d.appendChild(header); d.appendChild(scroll);
    header.querySelector('.mittis__close').addEventListener('click', function () { self.close(); });
    d.addEventListener('click', function (e) { if (e.target === d) self.close(); });
    d.addEventListener('close', function () { document.documentElement.classList.remove('mittis-lock'); });
    document.body.appendChild(d);
    this.dialog = d; this.scroll = scroll;
    this.values = {};
    this.render();
  };

  MittisWidget.prototype.render = function () {
    var self = this, charts = this.cfg.charts, chart = charts[this.active];
    var s = this.scroll; s.innerHTML = '';
    s.appendChild(h('p', { 'class': 'mittis__intro', text: this.t('intro') }));

    if (charts.length > 1) {
      var tabs = h('div', { 'class': 'mittis__tabs', role: 'tablist' });
      charts.forEach(function (c, i) {
        var b = h('button', { type: 'button', role: 'tab', 'aria-selected': String(i === self.active), 'class': 'mittis__tab', text: self.groupLabel(c.group) });
        b.addEventListener('click', function () { self.active = i; self.render(); });
        tabs.appendChild(b);
      });
      s.appendChild(tabs);
    }

    var form = h('form', { 'class': 'mittis__form', novalidate: '' });
    form.appendChild(h('h3', { 'class': 'mittis__subheading', text: this.t('measure_heading') }));
    (INPUTS[chart.group] || INPUTS.Bleiseri).forEach(function (pair) {
      var name = pair[0], rowKey = pair[1];
      if (!chart.parsed.rows[rowKey]) return;
      var helpKey = (name === 'waist' && chart.group === 'Housut') ? 'waist_trousers_help' : name + '_help';
      var id = 'mittis-' + name;
      var input = h('input', { id: id, name: name, type: 'number', inputmode: 'decimal', min: '20', max: '220', step: '0.5', 'class': 'mittis__input' });
      if (self.values[name] != null) input.value = self.values[name];
      form.appendChild(h('div', { 'class': 'mittis__field' }, [
        h('label', { 'for': id, 'class': 'mittis__label', text: self.t(name) }),
        h('div', { 'class': 'mittis__input-wrap' }, [input, h('span', { 'class': 'mittis__unit', text: self.t('cm') })]),
        h('p', { 'class': 'mittis__help', text: self.t(helpKey) })
      ]));
    });
    var submit = h('button', { type: 'submit', 'class': 'button button--xl mittis__submit', text: this.t('calculate') });
    form.appendChild(submit);
    var result = h('div', { 'class': 'mittis__result', 'aria-live': 'polite' });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var body = {};
      Array.prototype.forEach.call(form.querySelectorAll('input'), function (inp) {
        var v = num(inp.value);
        self.values[inp.name] = inp.value;
        var rowKey = { neck: 'collar', chest: 'chest', waist: 'waist', hip: 'hip', inseam: 'inseam' }[inp.name];
        if (v != null && v > 20) body[rowKey] = v;
      });
      self.showResult(result, chart, body);
    });
    s.appendChild(form);
    s.appendChild(result);

    s.appendChild(this.renderTable(chart));
    if (chart.image) {
      var det = h('details', { 'class': 'mittis__details' }, [
        h('summary', { text: this.t('show_chart') }),
        h('img', { src: chart.image, alt: chart.name, loading: 'lazy', 'class': 'mittis__image' })
      ]);
      s.appendChild(det);
    }
    s.appendChild(h('p', { 'class': 'mittis__disclaimer', text: this.t('disclaimer') }));
  };

  MittisWidget.prototype.renderTable = function (chart) {
    var self = this, t = chart.parsed;
    var wrap = h('div', { 'class': 'mittis__table-wrap' });
    wrap.appendChild(h('h3', { 'class': 'mittis__subheading', text: this.t('chart_heading') + ' (' + this.t('cm') + ')' }));
    var table = h('table', { 'class': 'mittis__table' });
    var trh = h('tr', {}, [h('th', { text: '' })]);
    t.sizes.forEach(function (sz) {
      trh.appendChild(h('th', { text: sz, 'class': self.onSale(sz) ? '' : 'mittis__na', title: self.onSale(sz) ? '' : self.t('not_sold') }));
    });
    table.appendChild(h('thead', {}, [trh]));
    var tb = h('tbody');
    t.order.forEach(function (k) {
      var r = t.rows[k];
      var tr = h('tr', {}, [h('th', { scope: 'row', text: self.rowLabel(k, r.label) })]);
      r.values.forEach(function (v) { tr.appendChild(h('td', { text: v == null ? '–' : String(v).replace('.', ',') })); });
      tb.appendChild(tr);
    });
    table.appendChild(tb);
    wrap.appendChild(table);
    return wrap;
  };

  MittisWidget.prototype.showResult = function (el, chart, body) {
    var self = this;
    el.innerHTML = '';
    if (!Object.keys(body).length) { el.appendChild(h('p', { 'class': 'mittis__warn', text: this.t('missing_input') })); return; }
    var r = recommend(chart, body, this.cfg.tags, this.sellable);
    if (!r) { el.appendChild(h('p', { 'class': 'mittis__warn', text: this.t('missing_input') })); return; }
    var soldOut = !!r.soldOut;
    var best = soldOut ? r.ideal.size : r.best.size;

    el.appendChild(h('h3', { 'class': 'mittis__subheading', text: this.t('result_heading') }));
    el.appendChild(h('p', { 'class': 'mittis__reco' }, [
      h('span', { text: this.t('recommended') + ' ' }), h('strong', { 'class': 'mittis__reco-size', text: best })
    ]));
    if (soldOut) el.appendChild(h('p', { 'class': 'mittis__warn', text: this.t('best_sold_out', { size: best }) }));
    else if (r.other) el.appendChild(h('p', { 'class': 'mittis__note', text: this.t('borderline', { other: r.other }) }));
    if (r.note) el.appendChild(h('p', { 'class': 'mittis__note', text: this.t(r.note) }));
    if (!soldOut) r.extra.forEach(function (k) { el.appendChild(h('p', { 'class': 'mittis__note', text: self.t(k) })); });

    var alts = null;
    if (soldOut) {
      alts = h('div', { 'class': 'mittis__alts-wrap', 'aria-live': 'polite' }, [h('p', { 'class': 'mittis__note', text: this.t('alt_loading') })]);
      el.appendChild(alts);
    }

    /* palkit ensisijaisesta mitasta */
    var k = r.prim;
    var bars = h('div', { 'class': 'mittis__bars' });
    bars.appendChild(h('p', { 'class': 'mittis__legend', text: this.rowLabel(k, '') + ' · ' + this.t('legend') }));
    var scale = h('div', { 'class': 'mittis__scale' }, [
      h('span', { text: this.t('fit_tight') }), h('span', { text: this.t('fit_ideal') }), h('span', { text: this.t('fit_loose') })
    ]);
    bars.appendChild(scale);
    r.sizes.forEach(function (sz) {
      var p = sz.per[k]; if (!p) return;
      var span = (p.hi - p.lo) || 1;
      var pos = (p.g - p.lo) / span;                 /* 0 = tiukka raja, 1 = väljä raja */
      var pct = Math.max(0, Math.min(1, (pos + 0.5) / 2)) * 100;
      var cls = 'mittis__bar' + (sz.size === best ? ' is-best' : '') + (self.sellable(sz.size) ? '' : ' is-na');
      var row = h('div', { 'class': cls }, [
        h('span', { 'class': 'mittis__bar-size', text: sz.size }),
        h('span', { 'class': 'mittis__bar-track' }, [
          h('span', { 'class': 'mittis__bar-zone' }),
          h('span', { 'class': 'mittis__bar-dot', style: 'left:' + pct.toFixed(1) + '%' })
        ]),
        h('span', { 'class': 'mittis__bar-val', text: String(p.g).replace('.', ',') })
      ]);
      bars.appendChild(row);
    });
    el.appendChild(bars);

    /* Valintanappi vain saatavilla olevalle koolle: normaalisti suositus, loppuneen kohdalla vain jos varakoko on mittojen rajoissa. */
    var pick = soldOut ? r.alsoFits : best;
    if (pick) {
      if (soldOut) el.appendChild(h('p', { 'class': 'mittis__note', text: this.t('also_fits', { size: pick, ideal: best }) }));
      var btn = h('button', { type: 'button', 'class': 'button button--secondary mittis__select', text: this.t('select_size', { size: pick }) });
      var msg = h('p', { 'class': 'mittis__msg', 'aria-live': 'polite' });
      btn.addEventListener('click', function () {
        var ok = self.selectSize(pick);
        msg.textContent = ok ? self.t('size_selected', { size: pick }) : self.t('size_not_found', { size: pick });
        if (ok) setTimeout(function () { self.close(); }, 700);
      });
      el.appendChild(btn); el.appendChild(msg);
    }

    if (soldOut) this.showAlternatives(alts, chart, body, best);
    this.track(chart, r, Object.keys(body).length);
  };

  /* Loppuneen koon tilalle: saman kategorian (kokoelman) tuotteet, joissa asiakkaan sopivin koko on saatavilla.
   * Jokaiselle ehdokkaalle lasketaan suositus sen omasta mittataulukosta, joten "koko" tarkoittaa
   * sitä kokoa, joka sopii juuri siinä tuotteessa – ei pelkkää samaa kokomerkintää. */
  MittisWidget.prototype.showAlternatives = function (wrap, chart, body, idealSize) {
    var self = this, token = {};
    this._altToken = token;
    var myKind = kindOf(this.cfg.charts);
    var wantKind = chartKind(chart);
    var cols = (this.cfg.collections || []).slice().sort(function (a, b) { return a.n - b.n; }).slice(0, 5);
    var MAX = 4;

    Promise.all(cols.map(function (c) { return fetchCollection(c.h); })).then(function (results) {
      if (self._altToken !== token) return;
      var seen = {}, found = [];
      results.forEach(function (data, ci) {
        var charts = data.charts && data.charts.length ? data.charts : (results.filter(function (d) { return d.charts && d.charts.length; })[0] || {}).charts || [];
        var list = [];
        (data.products || []).forEach(function (p) {
          if (p.handle === self.cfg.handle || seen[p.handle]) return;
          var pc = charts.filter(function (c) { return p.stems.indexOf(c.stem) > -1; });
          if (!pc.length || kindOf(pc) !== myKind) return;
          var c = pc.filter(function (x) { return chartKind(x) === wantKind; })[0];
          if (!c) return;
          var avail = {};
          p.sizes.forEach(function (sv) { avail[normSize(sv[0])] = sv[1]; });
          var rr = recommend(c, body, p.tags, function (s) { return avail[s] != null; });
          if (!rr || rr.soldOut || rr.note === 'too_large') return;
          if (rr.best.hardFail > 0) return;
          list.push({ p: p, size: rr.best.size, variant: avail[rr.best.size], score: rr.best.score, rank: ci });
        });
        list.sort(function (a, b) { return a.score - b.score; });
        list.forEach(function (x) { if (!seen[x.p.handle]) { seen[x.p.handle] = 1; found.push(x); } });
      });
      found = found.slice(0, MAX);
      wrap.innerHTML = '';
      if (!found.length) { wrap.appendChild(h('p', { 'class': 'mittis__note', text: self.t('alt_none') })); self.trackAlt(chart, 0); return; }
      wrap.appendChild(h('h3', { 'class': 'mittis__subheading', text: self.t('alt_heading', { size: idealSize }) }));
      var ul = h('ul', { 'class': 'mittis__alts' });
      found.forEach(function (x) {
        var href = x.p.url + (x.p.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + x.variant;
        var a = h('a', { 'class': 'mittis__alt', href: href }, [
          x.p.img ? h('img', { src: x.p.img, alt: '', loading: 'lazy', width: '180', height: '225', 'class': 'mittis__alt-img' }) : null,
          h('span', { 'class': 'mittis__alt-info' }, [
            h('span', { 'class': 'mittis__alt-vendor', text: x.p.vendor }),
            h('span', { 'class': 'mittis__alt-title', text: x.p.title }),
            h('span', { 'class': 'mittis__alt-price', text: x.p.price }),
            h('span', { 'class': 'mittis__alt-size', text: self.t('alt_size', { size: x.size }) })
          ])
        ]);
        a.addEventListener('click', function () { self.trackAlt(chart, found.length, x.p.handle); });
        ul.appendChild(h('li', {}, [a]));
      });
      wrap.appendChild(ul);
      self.trackAlt(chart, found.length);
    });
  };

  MittisWidget.prototype.trackAlt = function (chart, count, clicked) {
    var ev = clicked ? 'mittis_alternative_click' : 'mittis_alternatives_shown';
    var p = { chart_key: chart.name, alternatives: count };
    if (clicked) p.product = clicked;
    try {
      if (typeof window.gtag === 'function') window.gtag('event', ev, p);
      else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: ev }, p));
    } catch (e) { /* ei kaadeta sivua */ }
  };

  /* Valitsee koon Prestigen variant-pickeristä (radio-swatch tai dropdown). */
  MittisWidget.prototype.selectSize = function (size) {
    var want = normSize(size);
    var idx = parseInt(this.getAttribute('data-size-index') || '0', 10) + 1;
    var inputs = document.querySelectorAll('variant-picker input[name="option' + idx + '"]');
    for (var i = 0; i < inputs.length; i++) {
      if (normSize(inputs[i].value) === want) {
        var label = document.querySelector('label[for="' + inputs[i].id + '"]');
        if (label) label.click(); else { inputs[i].checked = true; inputs[i].dispatchEvent(new Event('change', { bubbles: true })); }
        return true;
      }
    }
    var opts = document.querySelectorAll('variant-picker [data-option-value][role="option"]');
    for (var j = 0; j < opts.length; j++) {
      if (normSize(opts[j].value || opts[j].getAttribute('value')) === want) { opts[j].click(); return true; }
    }
    return false;
  };

  /* GA4: vain koko ja taulukon nimi – ei koskaan asiakkaan mittoja. */
  MittisWidget.prototype.track = function (chart, r, count) {
    var p = { chart_key: chart.name, recommended_size: (r.soldOut ? r.ideal : r.best).size, best_sold_out: !!r.soldOut, is_borderline: !!r.other, measurements_given: count };
    try {
      if (typeof window.gtag === 'function') window.gtag('event', 'mittis_size_calculated', p);
      else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: 'mittis_size_calculated' }, p));
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('mittis_size_calculated', p);
    } catch (e) { /* ei kaadeta sivua */ }
  };

  if (!window.customElements.get('mittis-widget')) window.customElements.define('mittis-widget', MittisWidget);
  window.Mittis = { parseTable: parseTable, recommend: recommend, easeFor: easeFor, normSize: normSize, kindOf: kindOf, chartKind: chartKind, fetchCollection: fetchCollection };
})();
